import {getTestProps} from '@benchling/js-test-utils';
import {Moment} from 'moment';
import React from 'react';
import _ from 'underscore';

import {CalendarFilesByDate} from 'calendar/CalendarConstants';

import DailyFileActivity from './DailyFileActivity';

interface WeeklyFileActivityProps {
  files: CalendarFilesByDate;
  weekStart: Moment;
}

function WeeklyFileActivity({files, weekStart}: WeeklyFileActivityProps): JSX.Element {
  return (
    <table className="calendarTable" {...getTestProps({component: 'Week', element: 'fileActivity'})}>
      <tbody>
        <tr>
          {_.range(7).map((dayNum) => {
            const date = weekStart.clone().add(dayNum, 'days');
            return (
              <DailyFileActivity
                key={dayNum}
                compact={true}
                files={files[date.format('YYYY-MM-DD')] || []}
                renderAsTD={true}
              />
            );
          })}
        </tr>
      </tbody>
    </table>
  );
}

export default WeeklyFileActivity;
